export default __webpack_public_path__ + "static/media/mello.52f0e44a.svg";